import { Outlet, Navigate } from "react-router";
import { routes } from "./routes";
import { getSessionData } from "services/session.service";

const AuthGuard = ({ isProtected = true }) => {
  const email = getSessionData("email");

  return isProtected ? (
    Boolean(email) ? (
      <Outlet />
    ) : (
      <Navigate to={routes.landing} />
    )
  ) : !Boolean(email) ? (
    <Outlet />
  ) : (
    <Navigate to={routes.home} />
  );
};

export default AuthGuard;
